import styled from "styled-components";

const Row = styled.div`
  display: flex;
  padding: 0.5rem 0;
  font-weight: ${({ closest }) => (closest ? "bold" : 300)};
`;

export default Row;
